define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var CustomerNoteCategoryModel = /** @class */ (function () {
        function CustomerNoteCategoryModel(data) {
            this.Id = ko.observable(0);
            this.Name = ko.observable();
            this.IsDefault = ko.observable(false);
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CustomerNoteCategoryModel.Mapping, self);
            }
        }
        CustomerNoteCategoryModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CustomerNoteCategoryModel(options.data);
            }
        };
        return CustomerNoteCategoryModel;
    }());
    return CustomerNoteCategoryModel;
});
//# sourceMappingURL=CustomerNoteCategoryModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CustomerNoteCategoryModel.js
// module id = 188
// module chunks = 2